<div class="dosage-type-manage-list">
  <div class="dosage-type-manage-list__toolbar">
    <mat-form-field appearance="outline" class="dosage-type-manage-list__search" subscriptSizing="dynamic">
      <mat-label>Search dosage types</mat-label>
      <input matInput type="text" [formControl]="searchControl" placeholder="Search dosage types" />
      <mat-icon matPrefix>search</mat-icon>
      @if (isSearching) {
        <mat-hint>Searching...</mat-hint>
      }
    </mat-form-field>
    <button type="button" mat-stroked-button class="dosage-type-manage-list__create" (click)="createDosageType()">
      <mat-icon>add</mat-icon>
      Create
    </button>
  </div>

  <div class="dosage-type-manage-list__items">
    @for (type of dosageTypes; track type.id) {
      <div class="dosage-type-manage-list__row">
        <span>{{ type.type }}</span>
        <button type="button" (click)="deleteDosageType(type)" mat-stroked-button class="dosage-type-manage-list__delete">
          Delete
        </button>
      </div>
    } @empty {
      <p class="dosage-type-manage-list__empty">No dosage types found.</p>
    }
  </div>
</div>
